import "@hotwired/turbo-rails";
import "../custom_actions";
import "../initializers";
import { showFlashToast } from "../utils/flash_toast";

window.showFlashToast = showFlashToast;

window.Turbo.config.forms.mode = "optin";

document.addEventListener("turbo:before-fetch-response", (event) => {
  if (event.detail.fetchResponse.response.status === 401) {
    event.preventDefault();
    window.location.href = "/";
  }
});

$(document).ajaxError((_event, jqXHR) => {
  if (jqXHR.status === 401) {
    window.location.href = "/";
  }
});
